import { AfterViewInit, Directive, ElementRef, Inject } from "@angular/core";
import { HeaderService } from "@app/components/header/header.service";

@Directive({
    selector: '[appHeaderBar]'
})
export class HeaderBarDirective implements AfterViewInit {

    constructor(@Inject(ElementRef) private $el: ElementRef,
                @Inject(HeaderService) private headerService: HeaderService) {
        this.$el.nativeElement.remove();
    }

    ngAfterViewInit(): void {
        this.headerService.updateHeaderContent(this.$el);
    }

}
